import { 
  FiFileText, 
  FiMessageSquare, 
  FiShield, 
  FiUsers, 
  FiTruck, 
  FiUserCheck, 
  FiAward 
} from 'react-icons/fi';

export const allergenChecklistData = [
  {
    id: 1,
    number: 1,
    title: "Allergen Information & Documentation",
    description: "Ensure allergen information is accurate and up to data.",
    icon: FiFileText,
    isExpanded: true,
    status: null, // can be 'pass' | 'issue' | null
    subItems: [
      { id: "1_1", text: "All menu items have allergen information available", checked: false },
      { id: "1_2", text: "Allergen matrix is complete and up to date", checked: false },
      { id: "1_3", text: "New menu items / recipes added to allergen matrix", checked: false },
      { id: "1_4", text: "Allergen matrix reviewed this month", checked: false }
    ]
  },
  {
    id: 2,
    number: 2,
    title: "Menu & Customer Communication",
    description: "Verify allergen information is clearly communicated.",
    icon: FiMessageSquare,
    isExpanded: true,
    status: null,
    subItems: [
      { 
        id: "2_1", 
        text: "Allergen notice displayed on menus", 
        checked: false,
        exampleText: "Example: \"Please inform our staff if you have any allergies.\""
      },
      { id: "2_2", text: "Daily specials / blackboard menu reviewed", checked: false },
      { id: "2_3", text: "Online ordering platforms updated", checked: false },
      { id: "2_4", text: "Takeaway packaging includes allergen info (where applicable)", checked: false }
    ]
  },
  {
    id: 3,
    number: 3,
    title: "Cross Contamination Controls",
    description: "Check procedures to prevent cross contamination.",
    icon: FiShield,
    isExpanded: false,
    status: null,
    subItems: [
      { id: "3_1", text: "Separate utensils and equipment available", checked: false },
      { id: "3_2", text: "Colour coding system followed", checked: false },
      { id: "3_3", text: "Surfaces and equipment cleaned between allergen tasks", checked: false },
      { id: "3_4", text: "Separate storage for allergenic ingredients", checked: false }
    ]
  },
  {
    id: 4,
    number: 4,
    title: "Staff Knowledge & Training",
    description: "Ensure staff are trained and aware of allergen requirements.",
    icon: FiUsers,
    isExpanded: true,
    status: null,
    subItems: [
      { id: "4_1", text: "All staff know the 14 allergens", checked: false },
      { id: "4_2", text: "New staff received allergen training", checked: false },
      { id: "4_3", text: "Refresher training completed within last 12 months", checked: false },
      { id: "4_4", text: "Training records available and up to data", checked: false }
    ]
  },
  {
    id: 5,
    number: 5,
    title: "Supplier Allergen Information",
    description: "Ensure supplier allergen declarations are available.",
    icon: FiTruck,
    isExpanded: false,
    status: null,
    subItems: [
      { id: "5_1", text: "Supplier allergen declarations available", checked: false },
      { id: "5_2", text: "Record product / ingredient changes reviewed", checked: false },
      { id: "5_3", text: "New suppliers assessed for allergen information", checked: false }
    ]
  },
  {
    id: 6,
    number: 6,
    title: "Customer Allergy Procedure",
    description: "Verify procedure for handling customer allergy requests.",
    icon: FiUserCheck,
    isExpanded: false,
    status: null,
    subItems: [
      { id: "6_1", text: "Allergy communication procedure available", checked: false },
      { id: "6_2", text: "Staff understand escalation process", checked: false },
      { id: "6_3", text: "Incident reporting procedure understood", checked: false }
    ]
  },
  {
    id: 7,
    number: 7,
    title: "Manager Verification",
    description: "Manager to review and confirm all allergen controls are effective.",
    icon: FiAward,
    isExpanded: false,
    status: null,
    subItems: [
      { id: "7_1", text: "All allergen controls verified", checked: false },
      { id: "7_2", text: "Any issues identified and resolved", checked: false },
      { id: "7_3", text: "Records and documentation complete", checked: false }
    ]
  }
];
